<template>
  <v-dialog
    :model-value="open"
    :persistent="persistent"
    no-click-animation
    max-width="720"
    scrim="white"
    class="message-dialog-overlay"
    @update:model-value="$emit('update:open', $event)"
  >
    <v-card class="message-dialog text-center" :class="{ closable }" rounded="lg" v-bind="$attrs">
      <v-btn
        v-if="closable"
        flat
        rounded="pill"
        append-icon="fa-regular fa-xmark"
        class="message-dialog-close"
        data-testid="MessageDialogClose"
        :disabled="closeDisabled"
        @click="$emit('close')"
      >
        Aizvērt
      </v-btn>

      <v-icon v-if="icon" :icon="icon" size="32" class="align-self-center mb-4" />

      <div v-if="$slots.overline" class="message-dialog-text mb-4">
        <slot name="overline" />
      </div>

      <div v-if="title || $slots.title" class="message-dialog-title">
        <slot name="title">{{ title }}</slot>
      </div>

      <div v-if="text || $slots.text" class="message-dialog-text" :class="{ 'mt-4': title || $slots.title }">
        <slot name="text">{{ text }}</slot>
      </div>

      <slot />

      <div
        v-if="$slots.actions"
        class="message-dialog-actions mt-8 d-flex justify-center gap-10"
        :class="actionsInRow ? 'flex-nowrap' : 'flex-column flex-sm-row'"
      >
        <slot name="actions" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,

  props: {
    open: {
      required: true,
      type: Boolean,
    },

    title: {
      default: null,
      type: String as PropType<string | null>,
    },

    text: {
      default: null,
      type: String as PropType<string | null>,
    },

    icon: {
      default: null,
      type: String as PropType<string | null>,
    },

    closable: {
      default: false,
      type: Boolean,
    },

    closeDisabled: {
      default: false,
      type: Boolean,
    },

    persistent: {
      default: true,
      type: Boolean,
    },

    actionsInRow: {
      default: false,
      type: Boolean,
    },
  },

  emits: ["close", "update:open"],
}
</script>

<style lang="sass" scoped>
@use "~/assets/css/vuetify/settings" as *

.message-dialog-overlay
  backdrop-filter: blur(7px)

.message-dialog
  padding: 48px 24px 40px
  overflow-y: auto
  &.closable
    padding-top: 64px
  @media #{map-get($display-breakpoints, 'xs')}
    padding-left: 16px
    padding-right: 16px

.message-dialog-close
  position: absolute
  top: 12px
  right: 12px
  text-transform: none
  letter-spacing: 0.1px

.message-dialog-title
  font-size: 34px
  font-weight: 700
  line-height: 1.3

.message-dialog-text
  font-size: 16px
  line-height: 24px

.message-dialog-actions :deep(.v-btn)
  text-transform: none
  letter-spacing: 0.2px
  font-weight: 700
</style>
